export const ADMISSION_ENTER_ROUTE = "/admission/enter";
